/**
 * Payments environment detection with NO dependency on @stripe/stripe-js.
 *
 * Importing @stripe/stripe-js injects the 1 MB js.stripe.com script into the
 * page immediately, so pages that only need to know which environment is
 * configured (pricing tiers, billing links, team seats) import from here and
 * the Stripe library is loaded only when a checkout actually starts.
 */
export type StripeEnv = "sandbox" | "live";

export const stripeClientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as
  | string
  | undefined;

export function getStripeEnvironment(): StripeEnv {
  if (stripeClientToken?.startsWith("pk_test_")) return "sandbox";
  if (stripeClientToken?.startsWith("pk_live_")) return "live";
  throw new Error(
    "Stripe payments are not configured for this build. " +
      "Complete Stripe go-live to enable production checkout.",
  );
}
